import React, { FC, memo, useState } from 'react';
import { useCountdown } from './hooks/useCountdown';
import { Button, Col, Input, message, Row } from 'udesk-ui';
import { postSendMsg } from 'src/api/sendMsg';
import UdeskLocales from 'UdeskLocales';

export interface TemplateProps {
    value?: string;
    onChange?: (value: string) => void;
    params?: {
        mobile?: string;
        email?: string;
        password?: string;
    };
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, params } = props;

    const [isCounting, setIsCounting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const onGetCode = () => {
        setIsLoading(true);
        postSendMsg({ ...params })
            .then(() => {
                message.success(
                    /* 发送成功 */ UdeskLocales['current'].components.verifyModal.components
                        .verifyCodeInput.index.sentSuccessfully
                );
                setIsCounting(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onEnd = () => {
        setIsCounting(false);
    };

    const { countdown } = useCountdown({ onEnd, isCounting });

    return (
        <Input.Group>
            <Row gutter={10}>
                <Col span={12}>
                    <Input
                        value={value}
                        onChange={(e) => onChange?.(e.target.value)}
                        maxLength={6}
                    />
                </Col>

                <Col span={8}>
                    <Button
                        type="primary"
                        onClick={onGetCode}
                        disabled={isCounting || isLoading}
                        loading={isLoading}
                    >
                        {isCounting ? (
                            <span>
                                {/* 重新发送( */}
                                {
                                    UdeskLocales['current'].components.verifyModal.components
                                        .verifyCodeInput.index.resend
                                }
                                {countdown}s)
                            </span>
                        ) : (
                            <span>
                                {/* 发送验证码 */}
                                {
                                    UdeskLocales['current'].components.verifyModal.components
                                        .verifyCodeInput.index.sendVerificationCode
                                }
                            </span>
                        )}
                    </Button>
                </Col>
            </Row>
        </Input.Group>
    );
});

export default Template;
